import {
  HouseStudyDayGlobal,
  HouseStudyDayGlobalDto,
} from '../../../../../../../lib/graphql'
import {
  divideByFactor,
  multiplyByFactor,
} from '../../../../../../../utils/prices'

const computeInputPrice = (value: undefined | null | string | number) => {
  return value === '' || value === null || value === undefined
    ? null
    : multiplyByFactor(value)
}

export const computeHouseStudyDayGlobalInputs = ({
  isEnabled,
  options,
}: HouseStudyDayGlobalDto): HouseStudyDayGlobalDto => {
  const computedInputs: HouseStudyDayGlobalDto = {
    isEnabled,
    options: {
      capacity: {
        max: Number(options.capacity.max),
        min: Number(options.capacity.min),
      },
      seasonalPrices: [
        {
          endAt: options.seasonalPrices[0].endAt,
          startAt: options.seasonalPrices[0].startAt,
          highPrice: computeInputPrice(options.seasonalPrices[0].highPrice),
          lowPrice: computeInputPrice(options.seasonalPrices[0].lowPrice),
          mediumPrice: computeInputPrice(options.seasonalPrices[0].mediumPrice),
        },
      ],
      vatRate: options.vatRate,
    },
  }

  return computedInputs
}

const computeDefaultValuePrice = (value: undefined | null | number) => {
  return value === null || value === undefined ? null : divideByFactor(value)
}

export const computeHouseStudyDayGlobalDefaultValues = ({
  isEnabled,
  options,
}: HouseStudyDayGlobal): HouseStudyDayGlobalDto => {
  const computedInputs: HouseStudyDayGlobalDto = {
    isEnabled,
    options: options
      ? {
          ...options,
          seasonalPrices: [
            {
              endAt: options.seasonalPrices[0].endAt,
              startAt: options.seasonalPrices[0].startAt,
              highPrice: computeDefaultValuePrice(
                options.seasonalPrices[0].highPrice,
              ),
              lowPrice: computeDefaultValuePrice(
                options.seasonalPrices[0].lowPrice,
              ),
              mediumPrice: computeDefaultValuePrice(
                options.seasonalPrices[0].mediumPrice,
              ),
            },
          ],
        }
      : {
          capacity: { max: 0, min: 0 },
          seasonalPrices: [
            {
              endAt: null,
              startAt: null,
              highPrice: null,
              lowPrice: null,
              mediumPrice: null,
            },
          ],
          vatRate: null,
        },
  }

  return computedInputs
}
